import { computed, inject } from '@angular/core';
import { OffshoreReportState } from '@navstation-portal/reporting/data-model/offshore-report';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { OffshoreBunkerFormStore } from './form/bunker/offshore-bunker.store';
import { OffshoreConsumptionsFormStore } from './form/consumptions/offshore-consumptions.store';
import { OffshoreOperationalFormStore } from './form/operational/offshore-operational.store';
import { OffshorePositionAndWeatherFormStore } from './form/position-and-weather/offshore-position-and-weather.store';
import { OffshoreStockFormStore } from './form/stock/offshore-stock.store';
import { buildOffshoreVm } from './offshore-vm-builder';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withOffshoreReportComputed<_>() {
  return signalStoreFeature(
    type<{ state: OffshoreReportState }>(),
    withComputed(() => {
      const operationalStore = inject(OffshoreOperationalFormStore);
      const positionAndWeatherStore = inject(OffshorePositionAndWeatherFormStore);
      const consumptionsStore = inject(OffshoreConsumptionsFormStore);
      const bunkerStore = inject(OffshoreBunkerFormStore);
      const stockStore = inject(OffshoreStockFormStore);

      return {
        vm: computed(() => {
          return buildOffshoreVm({
            bunkerStore,
            consumptionsStore,
            operationalStore,
            positionAndWeatherStore,
            stockStore,
          });
        }),
      };
    })
  );
}
